export const getEnvFromHostname = () => {
  if (window.location.hostname === '0.0.0.0' || window.location.hostname === 'localhost') {
    return 'development';
  }
  const hostname = window.location.hostname.replace('.cloudinary.com', '');
  if (hostname.endsWith('staging')) {
    return 'staging';
  }
  if (hostname.endsWith('staging2')) {
    return 'staging2';
  }
  if (hostname.endsWith('nightly')) {
    return 'nightly';
  }
  return 'production';
};
